import { render, staticRenderFns } from "./board-list-item.vue?vue&type=template&id=8db2c524&scoped=true&"
import script from "./board-list-item.vue?vue&type=script&lang=ts&"
export * from "./board-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./board-list-item.vue?vue&type=style&index=0&id=8db2c524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db2c524",
  null
  
)

export default component.exports